import React from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import Model from '../../../../model';
import AutocompleteField from '../AutocompleteField';

const { block } = bem('specialist-search-field');
const SpecialistSearchField = ({names, placeholder = 'Поиск по имени или фамилии', setName, name}) => {

    const onChange = (event, value) => {
        setName(value ? value : null);
    }

    return (
        <AutocompleteField className={block()} name={'autocomplete-field'} value={name} options={names} onChange={onChange} blurOnSelect={true} placeholder={placeholder} noOptionsText={'Специалисты не найдены'}/>
    )
}

export default observer(SpecialistSearchField);
